<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">{{ isPreviewLetter ? 'Preview Letter' : 'Generate Letter' }}</div>

      <div _ngcontent-fup-c356="" class="cross" (click)="onClose()">
        <img _ngcontent-fup-c356="" style="height: 24px; width: 24px" src="assets/img/x.svg" alt="" />
      </div>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Radio Options -->
      <div *ngIf="!isPreviewLetter" class="radio-group">
        <label class="radio-option">
          <input type="radio" name="version" value="new" [(ngModel)]="selectedOption" />
          <div class="radio-custom"></div>
          <div class="radio-label">Create new version</div>
        </label>

        <label class="radio-option" style="margin-bottom: 0px">
          <input type="radio" name="version" value="no-issues" [(ngModel)]="selectedOption" />
          <div class="radio-custom"></div>
          <div class="radio-label">Create no issues version</div>
        </label>
      </div>

      <!-- User Selection -->
      <div class="user-selection">
        <label class="user-label" for="userSelect">User</label>
        <div class="user-dropdown">
          <div class="dropdown-button" (click)="toggleUserDropdown()">
            <div class="button-content">
              <div class="text" [class.selected]="selectedUser">{{ selectedUser || 'Choose here' }}</div>
            </div>
            <div class="arrow-container">
              <svg
                width="14"
                height="6"
                viewBox="0 0 14 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [class.rotated]="isUserDropdownOpen">
                <path
                  d="M1 1L7 5L13 1"
                  stroke="#6D7275"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="dropdown-menu" *ngIf="isUserDropdownOpen" [style.display]="isUserDropdownOpen ? 'block' : 'none'">
            <div class="menu-item" *ngFor="let user of adminArray" (click)="selectUser(user)">
              <div class="item-content">
                <div class="item-text">{{ user.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer" [ngClass]="{ 'preview-footer': isPreviewLetter }">
      <div class="preview-button" (click)="onPreview()" [class.disabled]="!isPreviewEnabled">
        <div class="preview-text">Preview</div>
        <div class="preview-icon">
          <img src="assets/img/svg/preview-letter.svg" alt="Preview Letter" class="menu-icon" />
        </div>
      </div>

      <div *ngIf="!isPreviewLetter" class="action-buttons">
        <div class="cancel-button" (click)="onCancel()">Cancel</div>
        <div class="proceed-button" *ngIf="!isPreviewLetter" (click)="onProceed()" [class.disabled]="!isProceedEnabled">
          Proceed
        </div>
      </div>
    </div>
  </div>
</div>
